<template lang="html">
  <div class="catalog-root-cards flex-1 bg-elevated">
    <div class="mx-auto w-full max-w-(--ui-container) px-4 py-5 sm:px-6 lg:py-6">
      <CategoryBreadcrumbs class="mb-3" />

      <div class="mb-5">
        <h1 class="text-2xl font-bold tracking-tight text-highlighted sm:text-3xl">
          Каталог
        </h1>
        <p class="mt-1 text-sm text-muted">
          Выберите категорию
        </p>
      </div>

      <div
        v-if="roots.length"
        class="grid grid-cols-2 gap-2.5 sm:grid-cols-3 sm:gap-3 lg:grid-cols-4"
      >
        <CategoryCard
          v-for="(category, index) in roots"
          :key="category.id"
          :category="category"
          :eager="index < 4"
        />
      </div>

      <div
        v-else
        class="flex flex-col items-center justify-center gap-3 py-16 text-muted"
      >
        <UIcon name="i-lucide-layout-grid" class="size-10 opacity-50" />
        <p class="text-sm">
          Категории пока недоступны
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CategoryBreadcrumbs from '#Products/components/Catalog/CategoryBreadcrumbs.vue'
import CategoryCard from '#Products/components/Catalog/CategoryCard.vue'

const { allRoot } = await useCategories()

const roots = computed(() =>
  [...(allRoot.value || [])].toSorted((a, b) => a.order - b.order),
)
</script>
